import {AgChartOptions, AgDonutSeriesOptions} from "ag-charts-community";

export class AgKpiSidebarUtil {
  public static defaultDonutOptions(
    data: { category: string; value: number }[],
    fillColors: string[],
    innerLabel: { text: string; fontSize?: number; color: string },
    tooltipContent?: (params: any) => string
  ): AgChartOptions {
    return {
      data: data,
      width: 130,
      height: 130,
      background: {
        visible: false,
      },
      series: [
        {
          type: 'donut',
          angleKey: 'value',
          calloutLabelKey: undefined,
          innerRadiusRatio: 0.6,
          fills: fillColors,
          legendItemKey: 'category',
          innerLabels: [
            {
              text: innerLabel.text,
              fontSize: innerLabel.fontSize || 12,
              color: innerLabel.color,
            },
          ],
          innerCircle: {
            fill: "DarkGray",
          },
          tooltip: {
            enabled: true,
            renderer: (params) => {
             return {
               color: "black",
               content: tooltipContent ? tooltipContent(params) : `${params.datum.value}`,
              };
            },
          },
        } as AgDonutSeriesOptions
      ],
      legend: {
        enabled: false,
      },
    } as AgChartOptions;
  }
}

